import { FC } from 'react';
import styled from '@emotion/styled';
import { Text } from 'components/_temp_ui_common/theme/Text';
import { Bendie, BendieAnimation, Motion } from 'components/bendies/Bendie';
import { Button } from 'components/core/button';
import { ExternalLink } from 'components/core/link/Link';

export const GreenScreenBackground = styled.div`
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  padding: 64px;
  margin: 20px;
  border-radius: 40px;
  border: 1px solid var(--green-1);
  background-color: var(--green-1);
  color: var(--green-6);
  text-align: center;
`;

const ErrorScreenBackground = styled(GreenScreenBackground)`
  border: 1px solid var(--red-1);
  background-color: var(--red-1);
  color: var(--neutral-gray-5);
`;

export const ErrorScreen: FC<{ onTryAgain: () => void }> = ({ onTryAgain }) => (
  <ErrorScreenBackground>
    <Text style={{ color: 'var(--purple-5)', paddingBottom: '16px' }} variant="h4">
      Oh no!
    </Text>
    <Text block style={{ paddingBottom: '24px' }}>
      Something went wrong when we tried to book this time slot.
    </Text>
    <Button onClick={onTryAgain} style={{ minHeight: 50 }}>
      Try again
    </Button>
    <Text block style={{ marginTop: '24px' }}>
      If you’re still having trouble, please call{' '}
      <ExternalLink
        href="tel:8005160975"
        bold
        style={{
          backgroundImage: `linear-gradient(
to top,#EED65B 50%,var(--red-1) 50%
)`,
          // @ts-expect-error textWrap is definitely allowed here, not sure why tsc complains
          textWrap: 'nowrap',
        }}
      >
        1-800-516-0975
      </ExternalLink>{' '}
      for support
    </Text>
    <BendieAnimation style={{ height: 200, marginTop: 'auto' }} bendie={Bendie.Gus} motion={Motion.Scratch} />
  </ErrorScreenBackground>
);
